export const outcomeGraphGeneralStatusStyles = `
.qbd-source-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  column-gap: 1rem;
  row-gap: 0.5rem;
  margin-top: 0.5rem;
  flex-wrap: wrap;
}
.qbd-source-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 0.5rem;
  cursor: pointer;
}
.qbd-report-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 1.25rem;
  gap: 1rem;
  font-size: var(--fs-md);
}
`;
